import script from "./SubscriptionExpiredDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionExpiredDialog.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionExpiredDialog.vue?vue&type=style&index=0&id=7c07be34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c07be34"]])

export default __exports__